const getRedirectPath = ({
  type,
  email_verified,
  organization_owner,
  organization_unverified,
  password_changed,
  onboarding_step,
}) => {
  if (type === "employer") {
    if (!email_verified || organization_unverified) {
      return "/verify-email";
    }

    if (!organization_owner && !password_changed) {
      return "/reset-password";
    }

    if (organization_owner && onboarding_step === 1) {
      return "/signup/referrals";
    }

    return "/employer";
  } else if (type === "job_seeker") {
    if (!email_verified) {
      return "/verify-email";
    }

    if (email_verified && onboarding_step === 1) {
      return "/signup/address";
    }

    if (email_verified && onboarding_step === 2) {
      return "/signup/user-referrals";
    }

    return "/jobseeker";
  }
};

export { getRedirectPath };
